import { ISubmitResponse, ISurveyActivity } from '@pbl/pbl-react-core/lib/models/survey/pbl/types';
import { ERROR_RESET, ISurveyAnswer, RESET, UPDATE_SURVEY_POST_RESPONSE } from '@pbl/pbl-react-core/lib/models/survey/types';
import { SurveyService } from '@pbl/pbl-react-core/lib/services';
import { DispatchMethod } from '../index';

export const submit = async (data: ISubmitResponse) => {
  try {
    return await SurveyService.submit(data);
  } catch (e: any) {
    console.error(e);
    return e?.payload;
  }
};

export const updateSurveyPostResponse = (answer: ISurveyAnswer) => (dispatch: DispatchMethod) => {
  dispatch({
    type: UPDATE_SURVEY_POST_RESPONSE,
    payload: answer
  });
};

export const resetError = () => (dispatch: DispatchMethod) => {
  dispatch({
    type: ERROR_RESET,
    payload: null
  });
};

export const reset = () => (dispatch: DispatchMethod) => {
  dispatch({
    type: RESET,
    payload: null
  });
};

export const getPlayerResponses = async (id: number) => {
  try {
    return await SurveyService.getResponses(id);
  } catch (e) {
    console.error(e);
  }
};

export const getSurvey = async (key: string): Promise<ISurveyActivity | undefined> => {
  try {
    return await SurveyService.getSurvey(key);
  } catch (e: any) {
    console.error(e);
  }
};
export const submitQuiz = async (data: ISubmitResponse) => {
  try {
    return await SurveyService.submitQuiz(data);
  } catch (e: any) {
    console.error(e);
    return e?.payload;
  }
};

export const submitPoll = async (data: ISubmitResponse) => {
  try {
    return await SurveyService.submitPoll(data);
  } catch (e: any) {
    console.error(e);
    return e?.payload;
  }
};
